var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMldFinger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j7p7o9biba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.605 37.6H11.849c-4.216 0-8.321-1.487-11.561-4.185L0 33.175v-16.2l.606-.15c6.896-1.724 11.036-6.73 11.36-13.736C12.024 1.826 13.116.8 14.4.8c2.647 0 4.8 2.172 4.8 4.84 0 8.409-1.97 14.106-5.854 16.932l-.942-1.294C15.851 18.77 17.6 13.507 17.6 5.64c0-1.787-1.435-3.24-3.2-3.24-.434 0-.817.35-.835.762-.35 7.555-4.699 13.008-11.965 15.053V32.42A16.493 16.493 0 0 0 11.849 36h13.756v1.6z",
    fill: "url(#09gunnfljb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.023 24.393-.605-1.482a15.87 15.87 0 0 0 1.347-.622l.742 1.416c-.466.245-.965.476-1.484.688z",
    fill: "url(#diht3sn0kc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 9.6h8.8v1.6h-8.8V9.6z",
    fill: "url(#5wtp5gczud)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 9.6h1.6v1.6H36V9.6z",
    fill: "url(#z621kgyqde)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2 9.6h1.6v1.6h-1.6V9.6z",
    fill: "url(#w4x7ci4jpf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 42.4h8V44h-8v-1.6z",
    fill: "url(#f8bddmparg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 42.4h1.6V44h-1.6v-1.6z",
    fill: "url(#nhqb1i0e2h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6 47.2a6.407 6.407 0 0 1-6.4-6.4c0-4.225 5.533-11.388 5.769-11.691l.631-.812.631.812c.236.303 5.77 7.465 5.77 11.691 0 3.529-2.872 6.4-6.4 6.4zm0-16.265c-1.757 2.422-4.8 7.176-4.8 9.865 0 2.647 2.153 4.8 4.8 4.8s4.8-2.153 4.8-4.8c0-2.69-3.043-7.443-4.8-9.865z",
    fill: "url(#vd16aosifi)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6 22.4h-6.866v-1.6H39.6c1.103 0 2-.897 2-2s-.897-2-2-2H16.96v-1.6H39.6c1.985 0 3.6 1.615 3.6 3.6s-1.615 3.6-3.6 3.6z",
    fill: "url(#laq9qk2wvj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2 28h-8a3.604 3.604 0 0 1-3.6-3.6c0-1.985 1.615-3.6 3.6-3.6h8c1.985 0 3.6 1.615 3.6 3.6S35.185 28 33.2 28zm-8-5.6c-1.103 0-2 .897-2 2s.897 2 2 2h8c1.103 0 2-.897 2-2s-.897-2-2-2h-8z",
    fill: "url(#y9tso1azmk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6 32.8h-6.4a3.604 3.604 0 0 1-3.6-3.6c0-1.256.669-2.438 1.746-3.086l.825 1.37A2.002 2.002 0 0 0 25.2 31.2h6.4a2.002 2.002 0 0 0 1.383-3.442L34.09 26.6A3.565 3.565 0 0 1 35.2 29.2c0 1.985-1.615 3.6-3.6 3.6z",
    fill: "url(#lphpq7jvdl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8 37.6h-5.6a3.604 3.604 0 0 1-3.6-3.6 3.62 3.62 0 0 1 1.746-3.085l.825 1.37A2.002 2.002 0 0 0 25.2 36h5.6a2.002 2.002 0 0 0 1.271-3.545l1.018-1.232c.832.688 1.31 1.7 1.31 2.777 0 1.985-1.615 3.6-3.6 3.6z",
    fill: "url(#6i003mijxm)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "09gunnfljb",
    x1: 0,
    y1: -35.903,
    x2: 25.605,
    y2: -35.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "diht3sn0kc",
    x1: 9.418,
    y1: 20.19,
    x2: 11.507,
    y2: 20.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5wtp5gczud",
    x1: 25.6,
    y1: 8.004,
    x2: 34.4,
    y2: 8.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z621kgyqde",
    x1: 36,
    y1: 8.004,
    x2: 37.6,
    y2: 8.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w4x7ci4jpf",
    x1: 39.2,
    y1: 8.004,
    x2: 40.8,
    y2: 8.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f8bddmparg",
    x1: 11.2,
    y1: 40.804,
    x2: 19.2,
    y2: 40.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nhqb1i0e2h",
    x1: 20.8,
    y1: 40.804,
    x2: 22.4,
    y2: 40.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vd16aosifi",
    x1: 35.2,
    y1: 9.444,
    x2: 48,
    y2: 9.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "laq9qk2wvj",
    x1: 16.96,
    y1: 8.019,
    x2: 43.2,
    y2: 8.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y9tso1azmk",
    x1: 21.6,
    y1: 13.619,
    x2: 36.8,
    y2: 13.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lphpq7jvdl",
    x1: 21.6,
    y1: 19.446,
    x2: 35.2,
    y2: 19.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6i003mijxm",
    x1: 21.6,
    y1: 24.247,
    x2: 34.4,
    y2: 24.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F328F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j7p7o9biba"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMldFinger);
export default __webpack_public_path__ + "static/media/mld-finger.b9027dc40dd5daf62b7826e4bfd1bc2f.svg";
export { ForwardRef as ReactComponent };